import { render, staticRenderFns } from "./TextHeightClamp.vue?vue&type=template&id=2e1f1748&"
import script from "./TextHeightClamp.vue?vue&type=script&lang=js&"
export * from "./TextHeightClamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports